import React from "react"
import ReactDom from "react-dom"

import { AppPack } from "./AppPack"

ReactDom.render(<AppPack />, document.getElementById("root"))
